export const menuIconStyle = {
  height: '15px',
  width: '15px',
  objectFit: 'contain',
  fontWeight: 'bold'
} as const;
